import React from "react";

export type CSVFileIconProps = {
  cx?: string;
};

export const CSVFileIcon: React.FC<CSVFileIconProps> = ({ cx = "" }) => {
  return (
    <svg
      width="18"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`CSVFileIcon ${cx}`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3a2 2 0 0 1 2-2h9.998l3.999 4.044V21a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3z"
        fill="#fff"
        stroke="#185634"
      />
      <path d="M1 8h15.997v8.533H1V8z" fill="#185634" />
      <path
        d="M5.828 11.503a.868.868 0 0 0-.157-.393.8.8 0 0 0-.313-.257 1 1 0 0 0-.428-.09.984.984 0 0 0-.562.163c-.16.107-.283.262-.372.468-.087.205-.13.45-.13.737 0 .293.044.542.132.748.089.204.213.358.372.464.16.104.345.156.556.156.156 0 .296-.028.422-.084a.822.822 0 0 0 .48-.621l.864.004a1.65 1.65 0 0 1-.892 1.264c-.257.133-.553.2-.888.2-.37 0-.699-.084-.988-.253a1.756 1.756 0 0 1-.679-.735C3.082 12.952 3 12.572 3 12.13c0-.44.082-.82.247-1.142.166-.322.394-.567.683-.736.29-.168.617-.253.982-.253.318 0 .603.06.858.178.254.12.462.292.623.519.162.226.261.494.299.806h-.864zM12.847 13.223h.038l1.004-3.166h.948l-1.422 4.149h-1.099l-1.422-4.15h.95l1.003 3.167zM9.683 11.244a.518.518 0 0 0-.211-.385c-.124-.092-.29-.138-.498-.138a.98.98 0 0 0-.364.061.525.525 0 0 0-.231.168.405.405 0 0 0-.078.245.368.368 0 0 0 .17.328c.118.08.28.144.486.193l.372.091c.379.086.678.229.898.427.22.198.332.46.333.789a1.15 1.15 0 0 1-.193.658c-.125.186-.308.33-.548.431a2.17 2.17 0 0 1-.852.152 2.23 2.23 0 0 1-.865-.154 1.247 1.247 0 0 1-.57-.455 1.376 1.376 0 0 1-.216-.742h.83c.01.136.049.251.118.345a.653.653 0 0 0 .284.21c.119.047.255.071.41.071.147 0 .276-.022.387-.065a.579.579 0 0 0 .26-.182.435.435 0 0 0 .092-.274.349.349 0 0 0-.08-.232.614.614 0 0 0-.234-.165c-.1-.046-.23-.088-.39-.127l-.45-.112c-.747-.183-1.12-.56-1.118-1.13a1.09 1.09 0 0 1 .199-.652c.134-.19.318-.338.554-.442.237-.105.504-.158.802-.158.3 0 .564.053.793.158.229.104.407.25.534.44.127.187.193.403.197.646h-.821z"
        fill="#fff"
      />
      <path
        clipRule="evenodd"
        d="M12.64 1v4.4h4.363L12.641 1z"
        stroke="#185634"
        strokeLinejoin="round"
      />
    </svg>
  );
};
